import React from 'react';
import { AcvtPromotion } from '../../../types/acvt';
import style from './style.module.scss';

interface PromotedBannerProps {
    promoObject: AcvtPromotion;
    onClick: () => void;
}

export const AcvtPromotedBanner: React.FC<PromotedBannerProps> = ({
    promoObject,
    onClick,
}) => {
    const hasPromoOfferTitle = (() => {
        const title = promoObject?.promotionalOffer?.title;
        if (typeof title !== 'string') {
            return false;
        }
        const normalized = title.trim();
        return normalized.length > 0 && normalized !== 'undefined';
    })();

    const tintedBackground = promoObject.backgroundColor
        ? `color-mix(in srgb, ${promoObject.backgroundColor} 15%, white)`
        : 'var(--Primary-1)';

    return (
        <button
            type="button"
            className={style.banner}
            style={{ backgroundColor: tintedBackground }}
            onClick={onClick}
        >
            <div className={style.image_section}>
                <img alt="" src={promoObject.thumbnail ?? ''} />
            </div>
            <div
                className={style.text_section}
                style={{
                    color:
                        promoObject.promotedBannerTextColor ??
                        'var(--Primary-8)',
                }}
            >
                <span className={style.title}>{promoObject.title}</span>
                {promoObject.subTitle && (
                    <span className={style.subtitle}>
                        {promoObject.subTitle}
                    </span>
                )}
            </div>
            {promoObject.type === 'coupon' && hasPromoOfferTitle && (
                <span className={style.sticker}>
                    {promoObject.promotionalOffer?.title}
                </span>
            )}
        </button>
    );
};
